<template>
  <tr :class="{ 'has-hours': showHoursColumn && !extra, 'is-extra': extra }">
    <td>{{ !extra ? item.work_type.name : item.work_extra_type.name }}</td>
    <td v-if="!extra">
      <template v-if="!edit">
        {{
          item.work_type.is_hourly == 0
            ? (item.size ? $roundNumberToTenths(item.size) : '0') + ' ' + item.work_type.measure
            : $formatTime(item.hours || 0) +
              (item.size
                ? ' (' + $roundNumberToTenths(item.size) + ' ' + item.work_type.measure + ')'
                : '')
        }}
      </template>
      <template v-else>
        <div class="grid">
          <BaseInput
            v-if="item.work_type.is_hourly == 1"
            v-model="time"
            inputType="time"
            :rules="['required']"
          />
          <BaseInput
            :width="200"
            v-model="item.size"
            inputType="number"
            :rules="item.work_type.is_hourly == 0 ? ['required'] : []"
          >
            <template v-slot:append-outer>{{ item.work_type.measure }}</template>
          </BaseInput>
        </div>
      </template>
    </td>
    <td v-if="!extra">
      <template v-if="!edit">
        <template v-if="showHoursColumn">
          <template v-if="showPieceworkHours">
            {{ $formatTime(item.piecework_time_hour || 0) }}
          </template>
          <template v-else>—</template>
        </template>
        <template v-else>
          {{ $formatTime(item.hours || 0) }}
        </template>
      </template>
      <template v-else>
        <BaseInput
          v-if="showPieceworkHoursInput"
          v-model="pieceworkTime"
          inputType="time"
        />
        <BaseInput
          v-else
          v-model="time"
          inputType="time"
          :rules="['required']"
        />
      </template>
    </td>
    <td v-else>
      <template v-if="!edit">
        {{ $formatTime(item.hours) }}
      </template>
      <template v-else>
        <BaseInput
          v-model="time"
          inputType="time"
          :rules="['required']"
        />
      </template>
    </td>
    <td class="note">
      <BaseInput
          v-if="edit"
          v-model="item.report"
      />
      <template v-else>
        {{ item.report ? item.report : '—' }}
      </template>
    </td>
    <td>
      <template v-if="!edit">
        {{ item.selected_block || '—' }}
      </template>
      <template v-else>
        <BaseInput
          v-model="selectedBlockModel"
          type="select"
          :items="blockOptions"
          clearable
        />
      </template>
    </td>
    <td class="actions">
      <div class="buttons">
        <DeleteModal
          v-if="
            $userCheckAccess({
              abilities: 'edit_work_days',
            })
          "
          ref="deleteModal"
          :text="
            localStorage.translations.pages.projects.reports_dialogs.delete_report +
            ' ' +
            (!extra ? item.work_type.name : item.work_extra_type.name)
          "
          :methodDelete="onDeleteItem"
        />
      </div>
    </td>
  </tr>
</template>

<script>
import DeleteModal from 'components/DeleteModal'
import { mapActions, mapGetters } from 'vuex'
import BaseInput from "components/base/BaseInput";
export default {
  name: 'TimeControlShowEmployeeDayTableItem',
  components: {BaseInput, DeleteModal },
  props: {
    item: Object,
    extra: Boolean,
    edit: Boolean,
    functionUpdate: Function,
    showHoursColumn: Boolean,
  },
  data: () => ({
    open: false,
    time: null,
    pieceworkTime: null,
  }),
  watch: {
    time() {
      if (this.time.length) {
        const [hours, minutes] = this.time.split(':')
        this.item.hours = parseInt(hours) * 60 + parseInt(minutes)
      } else {
        this.item.hours = null
      }
    },
    pieceworkTime() {
      if (this.pieceworkTime !== null && this.pieceworkTime !== '') {
        this.item.piecework_time_hour = this.parseMinutes(this.pieceworkTime)
      } else {
        this.item.piecework_time_hour = null
      }
    },
    edit() {
      this.time = this.$formatTimeMin(this.item.hours)
      this.pieceworkTime = this.formatTimeForInput(this.item.piecework_time_hour)
    },
  },
  computed: {
    showPieceworkHours() {
      return (
        !this.extra &&
        this.item?.work_type?.is_hourly == 0 &&
        this.item.piecework_time_hour !== null &&
        this.item.piecework_time_hour !== undefined
      )
    },
    showPieceworkHoursInput() {
      return !this.extra && this.item?.work_type?.is_hourly == 0
    },
    blockOptions() {
      const blocks = Array.isArray(this.item?.blocks) ? this.item.blocks : []
      return [
        {
          id: '',
          name: this.localStorage.translations.pages.common.text['not_specified'] || 'Not Specified',
        },
        ...blocks.map((block) => ({id: block, name: block}))
      ]
    },
    selectedBlockModel: {
      get() {
        return this.item?.selected_block || ''
      },
      set(value) {
        this.item.selected_block = value || null
      },
    },
  },
  methods: {
    ...mapActions('employeeWorkDay', [
      'onEmployeeWorkDay_periodReport_delete',
      'onEmployeeWorkDay_extra_delete',
    ]),
    parseMinutes(value) {
      if (typeof value === 'string' && value.includes(':')) {
        const [hours, minutes] = value.split(':')
        return Number(hours) * 60 + Number(minutes)
      }
      return Number(value)
    },
    formatTimeForInput(value) {
      if (value === null || value === undefined || value === '') return ''
      const roundedMinutes = Math.max(0, Math.round(Number(value)))
      return this.$formatTimeMin(roundedMinutes)
    },
    onDeleteItem() {
      this[
        !this.extra ? 'onEmployeeWorkDay_periodReport_delete' : 'onEmployeeWorkDay_extra_delete'
      ](this.item.id)
        .then((response) => {
          this.$store.dispatch(
            'popup/onMessage',
            {
              message:
                this.localStorage.translations.pages.common.notifications['uspeshno-udaleno'],
              IsError: false,
            },

            { root: true },
          )
          this.$refs.deleteModal.dialog = false
          this.functionUpdate({ calendar: true })
        })
        .catch((err) => {
          this.$store.dispatch(
            'popup/onMessage',
            {
              message: this.localStorage.translations.pages.common.notifications['oshibka'],
              IsError: true,
            },
            { root: true },
          )
        })
    },
  },
}
</script>

<style lang="scss" scoped>
td {
  &.note {
    word-wrap: break-word;
  }
  .grid {
    display: grid;
    gap: 10px;
  }
  &.actions {
    width: 100px;
  }
}
tr:not(.has-hours):not(.is-extra) td {
  &:nth-child(1) {
    width: calc((100% - 100px) / 5);
  }
  &:nth-child(2) {
    width: calc((100% - 100px) / 5);
  }
  &:nth-child(3) {
    width: calc((100% - 100px) / 5);
  }
  &:nth-child(4) {
    width: calc((100% - 100px) / 5);
  }
  &:nth-child(5) {
    width: calc((100% - 100px) / 5);
  }
}
tr.has-hours td {
  &:nth-child(1) {
    width: calc((100% - 100px) / 5);
  }
  &:nth-child(2) {
    width: calc((100% - 100px) / 5);
  }
  &:nth-child(3) {
    width: calc((100% - 100px) / 5);
  }
  &:nth-child(4) {
    width: calc((100% - 100px) / 5);
  }
  &:nth-child(5) {
    width: calc((100% - 100px) / 5);
  }
}
tr.is-extra td {
  &:nth-child(1) {
    width: calc((100% - 100px) / 4);
  }
  &:nth-child(2) {
    width: calc((100% - 100px) / 4);
  }
  &:nth-child(3) {
    width: calc((100% - 100px) / 4);
  }
  &:nth-child(4) {
    width: calc((100% - 100px) / 4);
  }
}
</style>
